{
  "level": "field11",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:field11",
    "objects": "AREAS.E3:field11.e3",
    "mesh": "TREES.E3:field11.e3"
  },
  "spawn_point": {
    "position": [
      0.0,
      0.0,
      0.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      0.0,
      100.0,
      0.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      0.0,
      0.0,
      0.0
    ],
    "bbox_max": [
      0.0,
      0.0,
      0.0
    ],
    "vertex_count": 0,
    "vertices": []
  },
  "sectors": [
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2799.999755859375,
      "bbox_min": [
        -2799.999755859375,
        -4372.7998046875,
        1092.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4370.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}